import Vue from "vue";
import VueRouter from "vue-router";
import Pages from "../app/pages/";
import axios from "axios";
import MainRouter from "../app/pages/router";
import NotFound from "../app/pages/components/NotFound.vue";
import $i18n from "../i18n";
import ProfiloRouter from "../app/profilo/router";
import TestRouter from "../app/test/router";
import UtentiRouter from "../app/utenti/router";
import FatturazioneRouter from "../app/fatturazione/router";
import PrintServerRouter from "../app/printserver/router";
import ConfigurazioneRouter from "../app/configurazione/router";
import LogsRouter from "../app/utility/logs/router";
import SystemInfoRouter from "../app/systeminfo/router";
import QueryBuilderRouter from "../app/querybuilder/router";
import DataAnalysisRouter from "../app/dataanalysis/router";
import TaskManagerRouter from "../app/taskmanager/router";
import PrintReportRouter from "../app/printreport/router";
import NumeratoriRouter from "../app/numeratori/router";
import InstallationRouter from "../app/installation/router";
import ConfigurazioniRouter from "../app/configurazioni/router";
import CaseificioRouter from "../app/caseificio/router";
import IntegrazioneBusiness from "../app/integrazionebusiness/router";
import PapercleanRouter from "../app/paperclean/router";
import OrdiniRouter from "../app/ordini/router";

Vue.use(VueRouter);
// console.log("File Router");
// console.log(location);
// console.log(location.href);
const urlParams = new URLSearchParams(window.location.search);
const spidCode = urlParams.get("code");
// console.log(spidCode);
if (spidCode) {
	axios.get(process.env.VUE_APP_PATH_API + "/spidlogin", { params: { code: spidCode } })
		.then((baseresponse) => {
			// console.log(baseresponse);
			// let link = "http://localhost:8081/#/?language=it&authToken=" + baseresponse.data;
			// console.log(window.location);
			// console.log(link);
			window.location.replace(window.location.origin + "/#/?language=it&authToken=" + baseresponse.data.data);
		})
		.catch(() => {
			//location.replace(location.origin + "?test=OK");
		});
}

// let patientMain = [];
let mainChildren = MainRouter.concat(
	ProfiloRouter,
	TestRouter,
	UtentiRouter,
	FatturazioneRouter,
	PrintServerRouter,
	ConfigurazioneRouter,
	LogsRouter,
	SystemInfoRouter,
	QueryBuilderRouter,
	DataAnalysisRouter,
	TaskManagerRouter,
	PrintReportRouter,
	NumeratoriRouter,
	InstallationRouter,
	ConfigurazioniRouter,
	CaseificioRouter,
	IntegrazioneBusiness,
	PapercleanRouter,
	OrdiniRouter
);

// let patientChildren = patientMain.concat(

// );
// let rsaPatientChildren = patientMain.concat(RsaPazienteRouter);

// patientChildren.push({ path: "/paziente/*", component: NotFound });
// rsaPatientChildren.push({ path: "/rsapaziente/*", component: NotFound });

mainChildren.push({
	path: "*",
	component: NotFound,
});

const routes = [
	{
		name: "Login",
		path: "/login",
		component: Pages.Login,
		hidden: true,
	},
	// {
	// 	name: "Paziente",
	// 	path: "/paziente",
	// 	component: Paziente.Paziente,
	// 	children: patientChildren,
	// },
	// {
	// 	name: "RSA Paziente",
	// 	path: "/rsapaziente",
	// 	component: RasPaziente.RsaPazienteMainPage,
	// 	children: rsaPatientChildren,
	// },
	{
		path: "/",
		component: Pages.Main,
		children: mainChildren,
	},
	{
		path: "*",
		redirect: {
			name: "Login",
		},
	},
];

const router = new VueRouter({
	routes,
});

router.beforeEach((to, from, next) => {
	axios.defaults.params = { language: to.query.language };
	if (to.query.language) {
		$i18n.locale = to.query.language;
	}

	if (to.query.language === "it") {
		import("vue2-datepicker/locale/it");
	} else if (to.query.language === "tr") {
		import("vue2-datepicker/locale/tr");
	} else {
		import("vue2-datepicker/locale/en");
	}

	if (axios.defaults.params.language === undefined || axios.defaults.params.language === null) {
		axios.defaults.params = { language: "it" };
	}

	let loginData = {
		access_token: to.query.authToken,
	};
	if (!to.query.authToken) {
		loginData = {
			access_token: from.query.authToken,
		};
	}

	let accessToken = loginData == null ? undefined : loginData.access_token;

	if (to.path == "/login") {
		next();
	} else if (to.path == "/installation") {
		next();
	} else if (!to.query.authToken && accessToken) {
		if (to.path.includes("/paziente")) {
			if (from.query.idPaziente) {
				if (!to.path.includes("/paziente/edit") && !to.path.includes("/paziente/view")) {
					to.query.idPaziente = from.query.idPaziente;
				}
			}
		}
		to.query.language = $i18n.locale;
		to.query.authToken = accessToken;
		if (to.path === from.path && JSON.stringify(to.query) === JSON.stringify(from.query)) {
			return;
		}
		router.push({ path: to.path, query: to.query });
	} else {
		axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
		axios.defaults.headers["Content-Type"] = "application/json";
		//        axios.defaults.params = { language: $i18n.locale };
		if (to.name == "Login") {
			next();
		} else if (loginData === null || accessToken === undefined) {
			next("/login");
		} else {
			let link = process.env.VUE_APP_PATH_API + "/validate";
			axios.get(link)
				.then(() => {
					if (document.body.classList.contains("sa-body-sidebar-open")) {
						document.body.classList.remove("sa-body-sidebar-open");
					}
					next();
				})
				.catch(() => {
					localStorage.clear();
					next("Login");
				});
		}
	}
});
export default router;
